export const ROUTES = {
  HOME: '/',
  ADMIN: '/admin',
  AGENT: '/agent',
  DATASET: '/dataset',
  DATA_STUDIO: '/datastudio',
  PROJECTS: '/projects',
  WORKSPACES: '/workspaces',
  SETTINGS: '/settings',
  DATA_EGRESS: '/egress',
  MCP: '/mcp',
  UPLOAD: '/upload/:sessionId',
  BILLING: '/billing',
  DATA_SHARES: '/data-shares',
  DATA_CONSOLE: '/data-console',
  DATA_CONSOLE_SOURCES: '/data-console/sources/:projectId',
  KNOWLEDGE: '/knowledge',
  DASHBOARDS: '/dashboards',
  PRESENTATIONS: '/presentations',
  DOCUMENTS: '/documents',
  VIDEOS: '/videos',
  SCHEDULER: '/scheduler',
  ALERTS: '/alerts',
  AUDIT_LOGS: '/audit-logs',
  CREDITS: '/credits',
  REPORTS: '/reports',
  DIAGNOSTIC: '/diagnostic',
  FILES: '/files',
  PRIVATE_CONNECTIONS: '/private-connections',
  PRIVATE_CONNECTION_CREATE: '/private-connections/new',
  PRIVATE_CONNECTION_DETAIL: '/private-connections/:connectionId',
  MARKETPLACE: '/marketplace',
  SHARE_DASHBOARD: '/share/d/:dashboardId',
  REGISTER: '/register',
  UNSUBSCRIBE: '/unsubscribe',
} as const;

export const NON_WORKSPACE_ROUTES: readonly string[] = [
  ROUTES.WORKSPACES,
  ROUTES.ADMIN,
  ROUTES.HOME,
  '/callback',
  ROUTES.REGISTER,
];

export const SCOPED_ROUTES: readonly string[] = [
  ROUTES.PROJECTS,
  ROUTES.AGENT,
  ROUTES.DATASET,
  ROUTES.DATA_STUDIO,
  ROUTES.DASHBOARDS,
  ROUTES.PRESENTATIONS,
  ROUTES.DOCUMENTS,
  ROUTES.VIDEOS,
  ROUTES.KNOWLEDGE,
  ROUTES.SCHEDULER,
  ROUTES.ALERTS,
  ROUTES.AUDIT_LOGS,
  ROUTES.REPORTS,
  ROUTES.DATA_EGRESS,
  ROUTES.DATA_SHARES,
  ROUTES.DATA_CONSOLE,
  ROUTES.SETTINGS,
  ROUTES.MCP,
  ROUTES.BILLING,
  ROUTES.PRIVATE_CONNECTIONS,
  ROUTES.FILES,
];

export function isScopedRoute(pathname: string): boolean {
  return SCOPED_ROUTES.some((r) => pathname === r || pathname.startsWith(`${r}/`));
}

export function withScope(route: string, scope: { w: string; p?: string | null }): string {
  const params = new URLSearchParams({ w: scope.w });
  if (scope.p) params.set('p', scope.p);
  return `${route}?${params.toString()}`;
}

export function isWorkspaceSourcesPath(pathname: string): boolean {
  return pathname.startsWith(`${ROUTES.DATA_CONSOLE}/sources/`);
}

export function isPrivateConnectionsPath(pathname: string): boolean {
  return (
    pathname === ROUTES.PRIVATE_CONNECTIONS || pathname.startsWith(`${ROUTES.PRIVATE_CONNECTIONS}/`)
  );
}
